export default "__VITE_ASSET__NEkLi$tk__"